export const PaymentType = Object.freeze({
  SUBSCRIPTION: 'subscription',
  EVENT:        'event',
  MATRIMONY:    'matrimony',
  CRM:          'crm',
  FUNDING:      'funding',
  STARTUP_REGISTRATION: 'startup_registration',
  STARTUP_IDEAS: 'startup_ideas',
  MENTOR_MEETING:"mentor_meetings"
});